import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import Header from './Header';
import Footer from './Footer';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import danielle2 from "./images/danielle2.png";  
import celine2 from "./images/celine2.png";
import christine1 from "./images/christine1.png"
import guideFR from "../src/files/Devient-Une-Machine.pdf"
import guideEN from "../src/files/BurnFatNaturally-Guide.pdf";

//-------- Success Animation --------
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
const AboutPage = () => {
  const { t, i18n } = useTranslation();
  //------------------Coaches Section------------------------
const [reps, setReps] = useState([]);
const navigate = useNavigate();
const [formData, setFormData] = useState({ name: '', email: '' });
const [isSubmitting, setIsSubmitting] = useState(false);
const imagesCoach = {
  danielle2,
  celine2,
  christine2: christine1,
};

useEffect(() => {
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
  fetch(`${API_URL}reps`)
    .then((res) => res.json())
    .then((data) => setReps(data))
    .catch((error) => console.error("Error fetching reps!", error));
}, []);

  //------------------ Success Stories Section -----------------------
const [successStories, setSuccessStories] = useState([]);
  useEffect(() => {
    const fetchStories = async () => {
      try {
        const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
        const response = await fetch(`${API_URL}getSuccessStories`);
        const data = await response.json();

        const localizedStories = data.map(story => ({
          ...story,
          quote: story.quote[i18n.language] || story.quote.en,
          summary: story.summary[i18n.language] || story.summary.en,
        }));

        setSuccessStories(localizedStories);
      } catch (error) {
        console.error("Failed to fetch success stories:", error);
      }
    };
    fetchStories();
  }, [i18n.language]);

  const firstStory = successStories.length > 0 ? successStories[1] : null;
  //---------------- FAQ section -------------------------------
  const [activeIndex, setActiveIndex] = useState(null); 
  const toggleAnswer = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
  };
  const faqData = [
    {question: t('faq.ques1'), answer: t('faq.ans1')},
    {question: t('faq.ques2'), answer: t('faq.ans2')},
    {question: t('faq.ques3'), answer: t('faq.ans3')},
    {question: t('faq.ques4'), answer: t('faq.ans4')},
    {question: t('faq.ques5'), answer: t('faq.ans5')},
    {question: t('faq.ques6'), answer: t('faq.ans6')},
    {question: t('faq.ques7'), answer: t('faq.ans7')},
    {question: t('faq.ques8'), answer: t('faq.ans8')},
];

 const handleChange = (e) => {
             const { name, value } = e.target;
             setFormData({ ...formData, [name]: value });
           };
           
           const handleSubmit = async (e) => {
             e.preventDefault();
             setIsSubmitting(true);
             try {
               const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:8000/'}send-free-guide`, {
                 method: 'POST',
                 headers: { 'Content-Type': 'application/json' },
                 body: JSON.stringify(formData),
               });
           
               const resultText = await res.text();
               console.log("Server response:", resultText);
           
               if (res.ok) {
                 const currentLang = i18n.language;
                 const fileToDownload = currentLang === 'fr' ? guideFR : guideEN;
                 const link = document.createElement('a');
                 link.href = fileToDownload;
                 link.download = currentLang === 'fr'
                 ? 'Devient-Une-Machine.pdf'
                 : 'BurnFatNaturally-Guide.pdf';
                document.body.appendChild(link);
                 setTimeout(() => {
                   link.click();
                   document.body.removeChild(link);
                 }, 100);
           
                 setFormData({ name: '', email: '' });
               } else {
                 alert("Submission failed. Please try again.");
               }
             } catch (err) {
               console.error("Submission error:", err);
               alert("Oops! Something went wrong.");
             } finally {
               setIsSubmitting(false);
             }
           };

  return (
    <PageContainer>
      <Header />
      <MainContent>
        <Section>
          <Title>{t('about.Title1')}</Title>
          <Subtitle>{t('about.Sub1')}</Subtitle>
          <Paragraph>{t('about.Paragraph1')}</Paragraph>
          <Freeconsultation onClick={() => navigate("/consultation")}>{t("about.getStarted")}</Freeconsultation>
        </Section>
        <Section>
          <Title>{t('about.Title2')}</Title>
          <Paragraph>{t('about.Paragraph2')}</Paragraph>
          <Paragraph>{t('about.Paragraph3')}</Paragraph>
          <Paragraph>{t('about.Paragraph4')}</Paragraph>
          <Freeconsultation onClick={() => navigate("/consultation")}>{t("about.speakWith")}</Freeconsultation>
          </Section>
<SectionDownload>
<Title>{t("home.downloadTitle")}</Title>
<Paragraph>{t("home.readyTo")} </Paragraph>
<Paragraph>{t("home.listIntro")}</Paragraph>
<BulletList>
    <li>{t("home.listItem1")}</li>
    <li>{t("home.listItem2")}</li>
    <li>{t("home.listItem3")}</li>
    <li>{t("home.listItem4")}</li>
    <li>{t("home.listItem5")}</li>
  </BulletList>
  <form onSubmit={handleSubmit}>
  <FormInput type="text" name="name" placeholder={t("home.fullName")} value={formData.name} onChange={handleChange} required/>
  <br/>
  <FormInput type="email" name="email" placeholder={t("home.email")} value={formData.email} onChange={handleChange} required/>
  <br/>
  <DownloadButton type="submit" disabled={isSubmitting}>
    {isSubmitting ? t("home.loading") : t("home.downloadBtn")}
  </DownloadButton>
</form>
</SectionDownload>

        <Section>
        <Title>{t("about.Coach")}</Title>
        <CoachSection>
  {reps
  .filter(rep => rep.firstName !== "Véronique")
  .map((rep, index) => (
    <CoachCard key={rep._id} $reverse={index % 2 !== 0}>
      <CoachImagesWrapper $reverse={index % 2 !== 0}>
        <CoachImage src={imagesCoach[rep.image2]} alt={rep.firstName} />
      </CoachImagesWrapper>
      <CoachInfo $reverse={index % 2 !== 0}>
        <Meet>{t("coaches.meet")}</Meet>
        <CoachName>{rep.firstName} {rep.lastName}</CoachName>
        <CoachTitle>{rep.title[i18n.language]}</CoachTitle>
        <CoachDescription>{rep.quote[i18n.language]}</CoachDescription>
        <CoachSpan><Iam>{t("coaches.im")} {rep.firstName}</Iam></CoachSpan>
        <Button onClick={() => navigate(`/consultation?coach=${encodeURIComponent(rep.firstName + " " + rep.lastName)}`)}>
          {t("coaches.takeConsultation", { coach: rep.firstName })}
        </Button>
      </CoachInfo>
    </CoachCard>
  ))}
    <Button onClick={() => navigate("/coach")}>{t("coaches.viewAll")}</Button>
</CoachSection>
        </Section>

        <Section>
        <Title>{t('success.Success')}</Title>
         {firstStory ? (
            <Story>
              <Rightbox>
                <PersonInfo>
                  <Name>{firstStory.name}</Name>
                  <Divider />
                  <Lost>{t('success.Lost')} {firstStory.lost} {t('success.Pounds')}</Lost>
                </PersonInfo>
                <ImageRow>
                  {firstStory.images.map((src, i) => (
                    <Polaroid key={i} rotate={i === 0 ? "-8deg" : "8deg"}>
                      <P><IMG src={src} alt={`${firstStory.name} shot ${i+1}`} /></P>
                    </Polaroid>
                  ))}
                </ImageRow>
                <ButtonWrapper>
                  <p>{t('success.Inspired')}</p>
                  <button onClick={() => navigate("/success")}>{t('success.Start')}</button>
                </ButtonWrapper>
              </Rightbox>

              <DivQuoteMid>
                <Quotediv><p>{firstStory.quote}</p></Quotediv>
                <UnderPics><p>{firstStory.summary}</p></UnderPics>
              </DivQuoteMid>
            </Story>
          ) : (
            <p>{t('success.noStories')}</p>
          )}
      <CoachButton onClick={() => navigate("/success")}>{t('success.ViewSucc')}</CoachButton>
</Section>

        <Section>
        <FAQdiv>
        <FaqTitle>{t('footer.FAQ')}</FaqTitle>
        <div className="faq-list">
            {faqData.map((item, index) => (
            <div key={index} className="faq-item">
                <div className="faq-question" onClick={() => toggleAnswer(index)}>
                <span>{item.question}</span>
                <span className="faq-toggle-icon">{activeIndex === index ? '-' : '+'}</span>
                </div>
                {activeIndex === index && (
                <div className="faq-answer">
                    <p>{item.answer}</p>
                </div>
                )}
            </div>
            ))}
        </div>
    </FAQdiv>
        </Section>

      </MainContent>
      <Footer />
    </PageContainer>
  );
};

export default AboutPage;

const PageContainer = styled.div`
  background:linear-gradient(122deg, rgba(148,163,135,1) 0%, rgba(186,204,171,1) 43%, rgba(246,187,155,1) 83%, rgba(217,121,97,1) 100%);
  @media (max-width: 1024px) {
  /* Laptop adjustments */
}
@media (max-width: 768px) {
  /* Tablet adjustments */
}
@media (max-width: 480px) {
  /* Mobile adjustments */
}
* {
  box-sizing: border-box;
}
body {
  overflow-x: hidden;
}
`;
const MainContent = styled.div`
  max-width: 1200px;
   font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  margin: 0 auto;
  text-align: center;
`;
const Section = styled.section`
  margin-bottom: 20px;
`;
const SectionDownload = styled.section`
  margin-bottom: 60px;
  background-color: rgba(255, 255, 255, 0.2);
  padding: 30px;
  border-radius: 20px;
`;
const Freeconsultation = styled.button`
padding: 20px;
background-color: rgba(217,121,97,1);
color: white;
border: none;
box-shadow: 0 4px 24px white;
font-size: 18px;
border-radius: 30px;
margin-bottom: 20px;
cursor: pointer;
&:hover {
    background-color: rgb(218, 145, 127);
    transform: scale(1.05);
  }
`
const Title = styled.h2`
  font-family: 'Great Vibes', cursive;
  font-size: 55px;
`;
const Subtitle = styled.h3`
  font-size: 30px;
  margin-bottom: 10px;
  text-shadow: 2px 2px 10px rgba(255, 255, 255, 1);
`;
const Paragraph = styled.p`
  font-size: 22px;
  color: black;
  line-height: 1.6;
`;
const BulletList = styled.ul`
  list-style: none;
  margin: 20px 0 40px;
  li {
    font-size: 22px;
    color: black;
    margin-bottom: 12px;
    gap: 10px;
  }
`;
const FAQdiv = styled.div`
  margin-bottom: 250px;
  padding-top: 20px;
  height: 75vh;
  font-family: "Roboto Flex";
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  .faq-list {
    list-style-type: none;
    padding: 0;
  }
  .faq-item {
    border-bottom: 1px solid #eee;
    padding: 15px 0;
  }
  .faq-question {
    display: flex;
    justify-content: space-between;
    font-size: 25px;
    font-weight: bold;
    cursor: pointer;
    transition: color 0.3s ease;
  }
  .faq-question:hover {
    color:rgba(217,121,97,1);
  }
  .faq-toggle-icon {
    font-size: 1.5rem;
    font-weight: bold;
    color:rgba(148,163,135,1);
  }
  .faq-answer {
    padding-top: 10px;
    font-size: 22px;
    color: #555;
  }
`;
const FaqTitle = styled.p`
  font-size: 35px;
  font-weight: bold;
`
const CoachButton = styled.button`
  background-color: rgba(217,121,97,1);
  margin-top: 40px;
  color: white;
  border: none;
  padding: 14px 28px;
  font-size: 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  &:hover {
    background-color:rgb(218, 145, 127);
  }
`;
const Rightbox = styled.div`
  border-radius: 10px;
  max-width: 40%;
  min-width: 350px;
  height: 650px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media (max-width: 768px) {
    max-width: 100%;
    min-width: unset;
    height: auto;
    align-items: center;
  }
`;
const PersonInfo = styled.div`
  background-color: rgba(238, 238, 238, 0.4);
  border-radius: 10px;
  width: 100%;
  font-size: 25px;
  padding-top: 10px;
`;
const Name = styled.p`
  margin-bottom: -30px;
  margin-top: -2px;
  font-weight: bolder;
  font-size: 40px;
  text-shadow: 0 2px 12px white;
  font-family: 'Great Vibes', cursive;
`;
const Lost = styled.p`
  margin-top: -2px;
  padding-bottom: 10px;
  font-weight: bold;
  font-style: italic;
  color: rgb(233, 149, 129);
  text-shadow: 0 2px 12px black;
`;
const ImageRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: 20px;
`;
const Polaroid = styled.div`
  background-color: white;
  padding-bottom: 40px;
  width: 250px;
  box-shadow: 0px 4px 20px rgba(246, 187, 155, 1);
  margin-left: 20px;
  transform: rotate(${(props) => props.rotate || "0deg"});
  transition: transform 0.3s ease;
  &:hover {
    box-shadow: 0px 4px 20px rgba(186, 204, 171, 1);
    transform: rotate(${(props) => props.rotate || "0deg"}) scale(1.3);
  }
  @media (max-width: 768px) {
    width: 80%;
    margin: 10px auto;
    transform: none;
    &:hover {
      transform: scale(1.05);
    }
  }
`;
const IMG = styled.img`
  width: 90%;
  object-fit: cover;
  max-height: 400px;
  @media (max-width: 768px) {
    max-height: 250px;
  }
`;
const P = styled.p`
  background-color: white;
`;
const Divider = styled.hr`
  width: 100%;
  border: none;
  border-top: 2px dashed white;
  margin: 30px 0 10px;
`;
const Quotediv = styled.div`
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 65%;
  padding: 40px;
  font-size: 24px;
  border-radius: 10px;
  position: relative;
  font-style: italic;
  line-height: 1.5;
  animation: ${fadeIn} 1.5s ease forwards;
  &::before,
  &::after {
    content: '"';
    font-size: 80px;
    color: black;
    position: absolute;
    font-family: serif;
  }
  &::before {
    top: 10px;
    left: 20px;
  }
  &::after {
    bottom: 10px;
    right: 20px;
  }
  p {
    margin: 0;
    max-width: 500px;
  }
`;
const UnderPics = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px;
  margin-top: 20px;
  font-size: 20px;
`;
const Story = styled.div`
  animation: ${fadeIn} 1s ease-in-out;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 40px;
  background:rgba(84, 133, 51, 0.11);
  box-shadow: 0 8px 24px black;
  padding: 40px;
  border-radius: 10px;
  min-height: 650px;
  margin: 0% 10%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    margin: 0 5%;
    padding: 20px;
  }
`;
const DivQuoteMid = styled.div`
  display: flex;
  flex-direction: column;
  width: 55%;
  @media (max-width: 768px) {
    width: 100%;
    margin-top: 30px;
  }
`;
const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 4%;
  button {
    padding: 10px 20px;
    background-color: rgba(217,121,97,1);;
    color: white;
    font-size: 16px;
    font-weight: bold;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    &:hover {
    background-color: rgb(218, 145, 127);
    transform: scale(1.05);
  }
  }
  p {
    font-size: 18px;
    margin-bottom: 10px;
  }
`;
const CoachSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  padding: 20px;
  box-sizing: border-box;
  overflow-x: hidden; 
`;
const CoachCard = styled.div`
  display: flex;
  flex-direction: ${({ $reverse }) => ($reverse ? "row-reverse" : "row")};
  background-color: rgba(255,255,255,0.6);
  border-radius: 20px;
  padding: 20px;
  width: 100%;
  max-width: 900px;
  box-shadow: 2px 2px 12px grey;
  gap: 30px;
  align-items: center;
  box-sizing: border-box;
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;
const CoachImagesWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: ${({ $reverse }) => ($reverse ? "row-reverse" : "row")};
`;
const CoachImage = styled.img`
  width: 100%;
  max-width: 250px;
  height: auto;
  border-radius: 20px;
  object-fit: cover;
  @media (max-width: 768px) {
    max-width: 80%;
  }
`;
const CoachInfo = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const CoachName = styled.h2`
  font-size: 60px;
  margin: 0;
  font-family: "Great Vibes", cursive;
`;
const CoachTitle = styled.h4`
  font-size: 20px;
  margin-top: -20px;
  color: rgb(131, 145, 119);
`;
const CoachDescription = styled.p`
  font-size: 20px;
  margin-top: -20px;
`;
const CoachSpan = styled.span`
  font-size: 18px;
`
const Meet = styled.span`
  font-size: 20px;
  font-style: italic;
  font-weight: bold;
  margin-bottom: -10px;
`;
const Iam = styled.span`
  font-size: 20px;
  font-style: italic;
  font-weight: bold;
  color: #333;
`;

const Button = styled.button`
padding: 14px 28px;
    background-color: rgba(217,121,97,1);;
    color: white;
    font-weight: bold;
    font-size: 1.1rem;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    &:hover {
    background-color: rgb(218, 145, 127);
    transform: scale(1.05);
  }
`
  const DownloadButton = styled.button`
  display: inline-block;
  background-color: rgba(217,121,97,1);
  color: white;
  padding: 14px 28px;
  border-radius: 30px;
  font-size: 20px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 2px 2px 24px white;
  cursor: pointer;
  border: none;
  &:hover {
    background-color: rgb(218, 145, 127);
    transform: scale(1.05);
  }
`;
const FormInput = styled.input`
width: 250px;
height: 30px;
margin-bottom: 10px;
border-radius: 10px;
border: none;
`